export default __webpack_public_path__ + "static/media/gmaps.9cd98cdf.png";